// extracted by mini-css-extract-plugin
module.exports = {"bottomBordered":"accountBasic_bottomBordered__TcAZu","imgBox":"accountBasic_imgBox__1mjrm","pic":"accountBasic_pic__8OmDt","btns":"accountBasic_btns__2CtJ2"};